import { ACTIONS as commonActions } from '@common/InviteMemberModal/state/actions';

export const ACTIONS = {
  ...commonActions,
  ADD_NEWLY_CREATED_PROJECT_COMPANIES: 'addNewlyCreatedProjectCompanies',
  SET_PRODUCTS_ACCESSES: 'setProductsAccesses',
};
